// extracted by mini-css-extract-plugin
export default {"servicePointsForm":"servicePointsForm---zP192"};